// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mongosh-expandable-expandable-caret__2GJYR {\n  cursor: pointer;\n}\n", ""]);
// Exports
exports.locals = {
	"expandable-caret": "mongosh-expandable-expandable-caret__2GJYR"
};
module.exports = exports;
